module.exports = __webpack_public_path__ + "img/COO-Darojat-Yogi-Candra.56e6f395.jpg";